/*
 * Section forces et priorites : deux dimensions les plus solides et
 * deux leviers prioritaires issus du calcul local.
 */

import { TrendingUp, Target } from "lucide-react";

export const ForcesPrioritiesSection = ({ forces, priorites }) => (
  <section className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div>
      <div className="flex items-center gap-2 mb-1">
        <TrendingUp className="w-4 h-4 text-[#114E0B]" aria-hidden="true" />
        <h2 className="font-heading text-base font-semibold text-[#060606]">Tes deux forces actuelles</h2>
      </div>
      <p className="mb-3 text-[11px] leading-relaxed text-[#9E9E9E]" data-testid="bilan-forces-note">
        Ces dimensions apparaissent aujourd’hui comme les plus solides dans tes réponses.
      </p>
      <div className="space-y-3">
        {forces.map((force) => (
          <div key={force.key} data-testid="bilan-strength-card" className="rounded-2xl bg-white border border-[rgba(17,78,11,0.2)] p-4 shadow-[var(--shadow-sm)]">
            <div className="flex items-center justify-between gap-2">
              <h3 className="font-heading text-sm font-semibold text-[#060606]">{force.label}</h3>
              <span className="shrink-0 text-xs font-bold px-2 py-0.5 rounded-full bg-[rgba(17,78,11,0.08)] text-[#114E0B] tabular-nums">{force.score}/100</span>
            </div>
            <p className="mt-2 text-xs leading-relaxed text-[#333333]">{force.text}</p>
          </div>
        ))}
      </div>
    </div>
    <div>
      <div className="flex items-center gap-2 mb-1">
        <Target className="w-4 h-4 text-[#235277]" aria-hidden="true" />
        <h2 className="font-heading text-base font-semibold text-[#060606]">Tes deux priorités du moment</h2>
      </div>
      <p className="mb-3 text-[11px] leading-relaxed text-[#9E9E9E]" data-testid="bilan-priorities-note">
        Elles ne représentent pas un diagnostic. Elles indiquent simplement les domaines dans
        lesquels tes réponses montrent aujourd’hui le plus de marge de progression ou de compréhension.
      </p>
      <div className="space-y-3">
        {priorites.map((priority) => (
          <div key={priority.key} data-testid="bilan-priority-card" className="rounded-2xl bg-[#E2F6FF] border border-[rgba(35,82,119,0.18)] p-4">
            <div className="flex items-center justify-between gap-2">
              <h3 className="font-heading text-sm font-semibold text-[#0B2B44]">{priority.label}</h3>
              <span className="shrink-0 text-xs font-bold px-2 py-0.5 rounded-full bg-white text-[#235277] tabular-nums">{priority.score}/100</span>
            </div>
            <p className="mt-2 text-xs leading-relaxed text-[#0B2B44]">{priority.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
